module.exports = __webpack_public_path__ + "img/mainBanner-mob.png?a0b027d3a8443d311c301c0baea2f823";